import React,{useState} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import AddFaqForm from '../Components/Faqs/AddFaqForm'
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../firebase.config';
const AddFaq = () => {
    const [questions, setQuestions] = useState("")
    const [answer, setAnswer] = useState("")

    const addFaq = () =>{
        addDoc(collection(db, "faqs"),{
            questions:questions,
            answer:answer
     
         })
         setQuestions("")
         setAnswer("")
    }
  return (
    <div>
        <MultiLevelSidebar />
        <AddFaqForm questions={questions} setQuestion={setQuestions} answer={answer} addFaq={addFaq} setAnswer={setAnswer} />
    </div>
  )
}

export default AddFaq